<template>
  <div>
    <div class="panel">
      <el-input
          @change="loadList(1)"
          name="phone"
          ref="phone"
          v-model="search.phone"
          class="panel__input el-mini"
          placeholder="Поиск по имени / ID / телефону..."
          auto-complete="off"
          suffix-icon="el-icon-search"
          size="small"
          clearable
      />
      <el-button type="primary" @click="addClient">Добавить клиента</el-button>
    </div>

    <el-table @sort-change="editSort" v-loading="loading" :data="usersList" @row-click="openUser" class="zebra-table">
      <el-table-column width="70" prop="" label="">
        <template slot-scope="scope">
          <letters-avatar v-if="scope.row" :name="scope.row.name" size="32" type="mini"/>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="name" label="Клиент">
        <template slot-scope="scope">
          <div class="user-data">
            <div class="user-data__name">{{ scope.row.name }}</div>
            <div class="user-data__phone"> {{ scope.row.phone }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" width="70" prop="id" label="ID"></el-table-column>
      <el-table-column sortable="custom" prop="last_screening" label="Последнее посещение" :formatter="formatter">
        <template slot-scope="scope">

          <div class="time-point" v-if="scope.row.last_screening">
            <div class="time-point__date">{{ $root.dateDefault(scope.row.last_screening) }}</div>
            <div class="time-point__time"><i class="el-icon-time"></i> {{ $root.timeIso(scope.row.last_screening) }}
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="last_activity" label="Последняя активность">
        <template slot-scope="scope">

          <div class="time-point" v-if="scope.row.last_activity">
            <div class="time-point__date">{{ $root.dateDefault(scope.row.last_activity) }}</div>
            <div class="time-point__time"><i class="el-icon-time"></i> {{ $root.timeIso(scope.row.last_activity) }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="50" label="" align="right">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.check_appointment" content="Необходима валидация" placement="top">
            <attention-icon/>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        v-if="showPagination"
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="pagination.per_page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        @current-change="loadList"
    />

    <the-new-user-dialog
        :visible="visibleDialogNewUser"
        @close="visibleDialogNewUser = false"
        @created="createdUser"/>
  </div>
</template>

<script>
import Vue from "vue";
import VueMask from "v-mask";
import {mapActions} from "vuex";
import TheNewUserDialog from "@/components/dialog/TheNewUserDialog.vue";
import LettersAvatar from "@/components/elements/LettersAvatar"
import AttentionIcon from "@/components/icons/Attention";

Vue.use(VueMask)

export default {
  name: "users.list",
  data: function () {
    return {
      usersList: null,
      pagination: null,
      visibleDialogNewUser: false,
      loading: false,
      sort: {},
      search: {
        departmentId: 0,
        inspectionStatus: null,
        phone: null,
        id: null,
      },
    }
  },
  components: {
    TheNewUserDialog,
    LettersAvatar,
    AttentionIcon
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false;
    },

  },
  created() {
    this.setStageVisit(0)
    this.loadList();
  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
    }),
    formatter(row) {
      return row.address;
    },
    editSort(column) {

      this.loadList(1, {
        order: column.order,
        prop: column.prop
      })

    },
    addClient() {
      this.visibleDialogNewUser = true
    },
    createdUser(user) {
      this.$router.push({name: "user.item", params: {id: user.id}})
    },
    loadList(page = 1, sort = {}) {
      this.loading = true

      let params = {
        params: {
          page,
          limit: 15,
          sortedBy: sort.order === 'ascending' ? 'asc' : sort.order === 'descending' ? 'desc' : null,
          orderBy: sort.prop  ? sort.prop : null,
          search: this.search.phone ? this.search.phone : null,
        }
      }

      this.$api.user
          .list(params)
          .then((response) => {
            this.usersList = response.data.data
            // this.usersList = response.original.data

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            })
          })
          .finally(() => {
            this.loading = false;
          })
    },
    openUser(visit) {
      this.$router.push({name: "user.item", params: {id: visit.id}});
    },

  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.user-data {
  display: flex;
  justify-content: flex-start;
  align-content: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;


  &__name {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;

    color: #111111;
  }

  &__phone {
    font-size: 15px;
    line-height: 16px;

    color: #111;
    margin-left: 10px;

  }

}

.panel {

  display: flex;
  align-items: center;
  justify-content: space-between;


  margin: 16px 0 32px 0;

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #111;
    letter-spacing: -0.005em;


  }

  &__input {
    max-width: 260px;
  }

}

.input-box {
  &__select {
    width: 110px;
  }

  &__title {
    color: #8e8e93;
    font-size: 13px;
    line-height: 16px;
    padding: 0 5px;


    &_margin {
      margin-left: 10px;
    }
  }
}

.visits {
  margin: 0;
  padding-bottom: 20px;

}

.time-point {

  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: 0.4px;

  &__date {
    font-size: 15px;
    line-height: 16px;
    color: #111111;

  }

  &__time {
    margin-left: 10px;

    font-size: 15px;
    line-height: 16px;
    color: #8E8E93;
  }
}

.zebra-table {
  margin-top: 32px;

  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}
</style>
